"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0.5rem;\n  opacity: 0;\n  transform: translateY(50%);\n  transition: opacity 0.2s, transform 0.2s;\n\n  ", ":hover & {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 1;\n\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  max-width: 50rem;\n\n  &:hover {\n    background-color: var(--color-grey-light-2);\n  }\n\n  & > [data-meta='editable-action-view'] {\n    position: absolute;\n    right: 0;\n    transform: translateX(calc(100% + 4rem));\n    width: max-content;\n  }\n\n  & > [data-meta='action-preview'] {\n    position: absolute;\n    right: 0;\n    transform: translateX(calc(100% + 4rem + 25rem));\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.WrapperDiv = styled_components_1.default.div(_templateObject());
exports.TextOptionViewWrapperDiv = styled_components_1.default.div(_templateObject2());
exports.RemoveButtonWrapperDiv = styled_components_1.default.div(_templateObject3(), exports.TextOptionViewWrapperDiv);